import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { notifyError, notifyTopRight } from "../Common/Toaster";
import { changeImageOrder } from "../../../services/UserServices/UserService";

const imgBaseURl = process.env.REACT_APP_IMAGE_BASEURL;

const ChangeImageOrderModal = ({ show, id, images, table, onHide }) => {
  const [imageList, setImageList] = useState(images);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(imageList);
    const [reordered] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reordered);

    setImageList(items);
  };

  const handleOrderSubmit = async (e) => {
    e.preventDefault();

    if (imageList[0].type === "video") {
      notifyError("First image should be an image");
      return;
    }

    try {
      const reorderedImages = imageList.map((img) => img._id);

      const payload = { userId: id, imagesOrder: reorderedImages };

      await changeImageOrder(payload);
      notifyTopRight("Order is updated successfully");
      table();
      onHide();
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <form onSubmit={handleOrderSubmit}>
        <Modal.Body>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="image-list" direction="horizontal">
              {(provided) => (
                <div
                  className="d-flex flex-wrap gap-3"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {imageList.map((img, index) => (
                    <Draggable
                      key={img._id}
                      draggableId={img._id}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          className="border p-2 text-center"
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                          style={{
                            cursor: "grab",
                            width: 120,
                            ...provided.draggableProps.style,
                          }}
                        >
                          {img.type === "video" ? (
                            <video
                              controls
                              muted
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                display: "block",
                              }}
                            >
                              <source
                                src={imgBaseURl + img.url}
                                type="video/mp4"
                              />
                            </video>
                          ) : (
                            <img
                              src={imgBaseURl + img.url}
                              alt={`img-${index}`}
                              width={100}
                              height={100}
                              style={{ objectFit: "cover" }}
                            />
                          )}
                          <div>Order: {index + 1}</div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Modal.Body>

        <Modal.Footer>
          <button type="button" onClick={onHide} className="btn btn-danger">
            Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Save Order
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ChangeImageOrderModal;
